
export const root = {
    width: '1.25rem',
    height: '1.25rem',
    background: '{surface.card}',
    checkedBackground: '{surface.card}',
    checkedHoverBackground: '{surface.card}',
    disabledBackground: '{form.field.disabled.background}',
    filledBackground: '{surface.card}',
    borderColor: '{surface.border}',
    borderWidth: '2px',
    hoverBorderColor: '{primary.color}',
    focusBorderColor: '{primary.color}',
    checkedBorderColor: '{primary.color}',
    checkedHoverBorderColor: '{primary.hover.color}',
    checkedFocusBorderColor: '{primary.color}',
    checkedDisabledBorderColor: '{form.field.border.color}',
    invalidBorderColor: '{form.field.invalid.border.color}',
    shadow: 'none',
    focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: '{focus.ring.shadow}'
    },
    transitionDuration: '{form.field.transition.duration}',
    sm: {
        width: '1rem',
        height: '1rem'
    },
    lg: {
        width: '1.5rem',
        height: '1.5rem'
    }
};

export const icon = {
    size: '0.5rem',
    checkedColor: '{primary.color}',
    checkedHoverColor: '{primary.color}',
    disabledColor: '{form.field.disabled.color}',
    sm: {
        size: '0.375rem'
    },
    lg: {
        size: '0.625rem'
    }
};

export default {
    root,
    icon
};
